import { render, staticRenderFns } from "./PBNEFBreadCrumbs.vue?vue&type=template&id=266023c3&scoped=true&"
import script from "./PBNEFBreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./PBNEFBreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./PBNEFBreadCrumbs.vue?vue&type=style&index=0&id=266023c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266023c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VCardTitle,VCol,VRow,VSpacer})
